// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"ef6e03eb","292":"0696ec33","354":"978c6812","453":"eca5f793","485":"ae7a28ce","493":"71b85d24","538":"fecd1c8f","541":"9c1fdac3","555":"fd68fddb","572":"a8feadd4","706":"b6772799","730":"5e038942","877":"42b56f86","958":"32d06958"}[chunkId] + ".chunk.js";
};